$(function () {
    // $(".view-history").on("click", function () {
    //     $("#view-like-history").modal("show");
    //     $("li.tab1 label").trigger("click");
    //     let parent = $("#view-like-history");
    //     fetchProperty(parent);
    //     selectedProperties(parent);

    //     setTimeout(function () {
    //         checkSelection();
    //     }, 200);
    // });

    $("#fetch-property").on("click", function () {
        validatePropertyData();
        let parent = $("#history-property");
        fetchProperty(parent);

        setTimeout(function () {
            checkSelection();
        }, 200);
    });

    function selectedProperties(parent) {
        let selected = [];
        let type = "vp";
        selected.push(...saveCheck(type, parent));
        let locale = $("#locale").val();
        let selected_properties_text = "";
        switch (locale) {
            case "en":
                selected_properties_text = "Selected Properties";
                break;
            case "ja":
                selected_properties_text = "選択物件";
                break;
            case "zh-CN":
                selected_properties_text = "選択物件";
                break;
            default:
                title = property["title"];
                break;
        }

        selected_properties = selected_properties_text + ":</br>";
        selected.every(function (value, index) {
            if (index < 3) {
                return (selected_properties +=
                    "<span class='px-2'>" + value + "</span></br>");
            } else if (index == 3) {
                return (selected_properties +=
                    "<span class='px-2'>...</span></br>");
            } else {
                // do nothing
            }
        });

        $("#selected-properties").html(selected_properties);
    }

    function checkSelection() {
        let parent = null;

        if ($("#history-property").is(":visible")) {
            parent = $("#history-property");
        } else {
            parent = $("#view-like-history");
        }

        let type = "vp";
        let arr_cb = fetchCheckedID(type);
        let arr_properties = getProperties(type);

        if (arr_cb.length < 1) {
            $(parent).find("#btn-select-all-property").attr("disabled", false);
            $(parent).find("#btn-deselect-all-property").attr("disabled", true);
            $(parent).find("#btn-delete-property").attr("disabled", true);
            $(parent).find("#btn-like-property").attr("disabled", true);
            $(parent).find("#btn-unlike-property").attr("disabled", true);
        } else {
            $(parent)
                .find("#btn-deselect-all-property")
                .attr("disabled", false);
            $(parent).find("#btn-delete-property").attr("disabled", false);
            $(parent).find("#btn-like-property").attr("disabled", false);
        }

        type = "lp";
        arr_cb = fetchCheckedID(type);
        arr_properties = getProperties(type);

        if (arr_cb.length < 1) {
            $("#btn-unlike-property").attr("disabled", true);
        } else {
            $("#btn-unlike-property").attr("disabled", false);
        }
    }

    function fetchProperty(parent) {
        const vp_rent = $(parent).find("#viewed-properties-rent")[0];
        const vp_sale = $(parent).find("#viewed-properties-sale")[0];
        const lp_rent = $(parent).find("#liked-properties-rent")[0];
        const lp_sale = $(parent).find("#liked-properties-sale")[0];

        let type = "vp";
        let type2 = "is_rent";
        let viewed_property_rent = getProperties(type, type2);
        createTBElements(vp_rent, viewed_property_rent, type, type2, parent);

        // let type = "vp";
        type2 = "is_sale";
        let viewed_property_sale = getProperties(type, type2);
        createTBElements(vp_sale, viewed_property_sale, type, type2, parent);

        if ($(parent).is("#history-property")) {
            return;
        }

        type = "lp";
        type2 = "is_rent";
        let liked_property_rent = getProperties(type, type2);

        // fix liked properties order according to viewed properties order
        let sortOrder = liked_property_rent.map(function (a) {
            return a["slug"];
        });

        liked_property_rent.sort(function (a, b) {
            return sortOrder.indexOf(a["slug"]) - sortOrder.indexOf(b["slug"]);
        });

        createTBElements(lp_rent, liked_property_rent, type, type2, parent);

        // type = "lp";
        type2 = "is_sale";
        let liked_property_sale = getProperties(type, type2);

        // fix liked properties order according to viewed properties order
        sortOrder = liked_property_sale.map(function (a) {
            return a["slug"];
        });

        liked_property_sale.sort(function (a, b) {
            return sortOrder.indexOf(a["slug"]) - sortOrder.indexOf(b["slug"]);
        });

        createTBElements(lp_sale, liked_property_sale, type, type2, parent);

        checkSelection();
    }

    function createTBElements(el, arr_properties, type, type2, parent) {
        let locale = $("#locale").val();
        const base_url = window.location.origin;

        el.textContent = "";
        properties = arr_properties;

        let fi_lp = getProperties("lp", type2);

        if (arr_properties) {
            arr_properties.forEach((property) => {
                let d_container = document.createElement("div");
                let d_tbox = document.createElement("input");
                let d_label = document.createElement("label");
                let slug = property["slug"];

                d_tbox.type = "checkbox";
                d_tbox.id = type + "-" + slug;
                d_tbox.className =
                    slug + " property-cb" + " " + type + " form-check-input";

                if (type == "vp") {
                    let is_liked = findInProperty(slug, fi_lp);
                    if (is_liked) {
                        d_tbox.className += " is_liked";
                    }
                } else {
                    d_tbox.className += " is_liked";
                }

                d_tbox.addEventListener("change", propertyChecked);
                d_tbox.value = slug;
                d_tbox.name = type;
                d_container.appendChild(d_tbox);

                let title = "";
                switch (locale) {
                    case "en":
                        title = property["title"];
                        break;
                    case "ja":
                        title = property["ja_title"];
                        break;
                    case "zh-CN":
                        title = property["zhcn_title"];
                        break;

                    default:
                        title = property["title"];
                        break;
                }

                d_label.className += " form-check-label";
                d_label.className += " " + property["ptype"];
                d_label.innerHTML =
                    "<a href='" +
                    base_url +
                    "/properties/" +
                    (property["ptype"] == "is_rent" ? "rent" : "sale") +
                    "/" +
                    property["slug"] +
                    "' target='_blank'>" +
                    title +
                    "</a>";
                d_container.appendChild(d_label);

                d_container.className += " form-check";
                d_container.appendChild(d_tbox);
                el.appendChild(d_container);

                if ($(parent).is("#history-property")) {
                    if (addCheck(title)) {
                        $("." + slug).prop("checked", true);
                    }
                }
            });
        }
    }

    function propertyChecked() {
        let this_id = $(this).attr("id");
        let this_class = this_id.substring(3);

        checked = $(this).is(":checked");
        $("." + this_class).prop("checked", checked);

        checkSelection();

        let parent = null;
        if ($("#history-property").is(":visible")) {
            parent = $("#history-property");
        } else {
            parent = $("#view-like-history");
        }
        selectedProperties(parent);
    }

    $("#history-property #btn-select-all-property").click(function () {
        $("#history-property input:checkbox").each(function () {
            if (!$(this).is(":checked")) {
                $(this).trigger("click");
            }
        });
    });

    // $("#view-like-history #btn-select-all-property").click(function () {
    //     $("#view-like-history input:checkbox").each(function () {
    //         if (!$(this).is(":checked")) {
    //             $(this).trigger("click");
    //         }
    //     });
    // });

    $("#history-property #btn-deselect-all-property").click(function () {
        $("#history-property input:checkbox").each(function () {
            if ($(this).is(":checked")) {
                $(this).trigger("click");
            }
        });
    });

    // $("#view-like-history #btn-deselect-all-property").click(function () {
    //     $("#view-like-history input:checkbox").each(function () {
    //         if ($(this).is(":checked")) {
    //             $(this).trigger("click");
    //         }
    //     });
    // });

    // $("#btn-like-property").click(function () {
    //     let parent = $("#view-like-history");

    //     let type = "vp";
    //     let v_arr_cb = fetchCheckedID(type, parent);
    //     let v_properties = getProperties(type);

    //     type = "lp";
    //     let l_properties = getProperties(type);

    //     // when local storage is not yet set
    //     if (l_properties == null) {
    //         localStorage.setItem("liked_property", JSON.stringify([]));
    //         l_properties = [];
    //     }

    //     if (v_properties) {
    //         v_arr_cb.forEach((el) => {
    //             v_property = v_properties.find(
    //                 (v_property) => v_property.slug === el
    //             );
    //             if (v_property) {
    //                 if ($("#" + "lp-" + v_property.slug).length == 0) {
    //                     addProperty(l_properties, v_property);
    //                     setProperties(l_properties, type);
    //                 }
    //             }
    //         });
    //     }

    //     $("#viewed-properties-rent").empty();
    //     $("#liked-properties-rent").empty();
    //     fetchProperty(parent);
    // });

    // $("#btn-unlike-property").click(function () {
    //     let parent = $("#view-like-history");

    //     let type = "lp";
    //     let l_arr_cb = fetchCheckedID(type, parent);
    //     let l_properties = getProperties(type);

    //     if (l_properties) {
    //         l_arr_cb.forEach((el) => {
    //             l_property = l_properties.find(
    //                 (l_property) => l_property.slug === el
    //             );
    //             if (l_property) {
    //                 l_properties = removeProperty(l_property, l_properties);
    //                 setProperties(l_properties, type);
    //             }
    //         });
    //     }

    //     $("#viewed-properties-rent").empty();
    //     $("#liked-properties-rent").empty();
    //     fetchProperty(parent);
    // });

    // $("#btn-delete-property").click(function () {
    //     let locale = $("#locale").val();
    //     let confirm_message = "";
    //     switch (locale) {
    //         case "en":
    //             confirm_message = "Do you want to delete?";
    //             break;
    //         case "ja":
    //             confirm_message = "削除しますか？";
    //             break;
    //         default:
    //             confirm_message = "削除しますか？";
    //             break;
    //     }

    //     if (!confirm(confirm_message)) {
    //         return;
    //     }

    //     let parent = $("#view-like-history");

    //     let type = "vp";
    //     deleteCheck(type, parent);

    //     type = "lp";
    //     deleteCheck(type, parent);

    //     $("#viewed-properties-rent").empty();
    //     $("#liked-properties-rent").empty();
    //     fetchProperty(parent);
    //     checkSelection();
    //     selectedProperties(parent);
    // });

    // function deleteCheck(type, parent) {
    //     let arr_cb = fetchCheckedID(type, parent);
    //     let properties = getProperties(type);

    //     if (properties) {
    //         arr_cb.forEach((el) => {
    //             property = properties.find((property) => property.slug === el);
    //             if (property) {
    //                 properties = removeProperty(property, properties);
    //                 setProperties(properties, type);

    //                 let selection = $("#properties").val().split(", ");
    //                 let index = selection.indexOf(property.title);
    //                 if (index !== -1) {
    //                     selection.splice(index, 1);
    //                 }
    //                 $("#properties").val(selection.join(", "));
    //             }
    //         });
    //     }
    // }

    $("#btn-confirm-property").on("click", function () {
        let selected = [];
        let type = "vp";
        let parent = $("#history-property");
        selected.push(...saveCheck(type, parent));
        $("#properties").val(selected.join(", "));
    });

    $("#btn-confirm-property").trigger("click");

    function addCheck(slug) {
        let selection = $("#properties").val().split(", ");
        return selection.includes(slug);
    }

    function saveCheck(type, parent) {
        let arr_cb = fetchCheckedID(type, parent);
        let properties = getProperties(type);
        let selected = [];
        let locale = $("#locale").val();

        if (properties) {
            arr_cb.forEach((el) => {
                property = properties.find((property) => property.slug === el);
                if (property) {
                    let title = "";
                    switch (locale) {
                        case "en":
                            title = property.title;
                            break;
                        case "ja":
                            title = property.ja_title;
                            break;
                        case "zh-CN":
                            title = property.zhcn_title;
                            break;
                        default:
                            title = property.title;
                            break;
                    }
                    selected.push(title);
                }
            });
        }

        return selected;
    }

    function fetchCheckedID(type, parent) {
        let arr_cb = [];

        let el;
        if (parent) {
            el = $(parent).find(
                "input[type=checkbox][name=" + type + "]:checked"
            );
        } else {
            el = $("input[type=checkbox][name=" + type + "]:checked");
        }

        arr_cb = $(el)
            .map(function () {
                return this.value;
            })
            .get();

        return arr_cb;
    }

    function addProperty(property, item) {
        property_item = {
            slug: item["slug"],
            uuid: item["uuid"],
            title: item["title"],
            ja_title: item["ja_title"],
            zhcn_item: item["zhcn_item"],
            ptype: item["ptype"],
        };
        property.push(property_item);
    }

    function findInProperty(slug, properties) {
        let property = "";
        if (properties) {
            properties.forEach((el) => {
                if (el.slug == slug) {
                    property = el;
                }
            });
            return property;
        } else {
            return false;
        }
    }

    function removeProperty(property, properties) {
        const index = properties.indexOf(property);
        if (index > -1) {
            properties.splice(index, 1);
        }

        return properties;
    }

    function getProperties(type, type2 = null) {
        let properties = "";

        if (type == "vp") {
            properties = JSON.parse(localStorage.getItem("viewed_property"));
        } else {
            properties = JSON.parse(localStorage.getItem("liked_property"));
        }

        if (type2) {
            if (properties) {
                return properties.filter(function (val) {
                    return val["ptype"] == type2;
                });
            } else {
                return [];
            }
        } else {
            return properties;
        }
    }

    function setProperties(properties, type) {
        if (type == "vp") {
            localStorage.setItem("viewed_property", JSON.stringify(properties));
        } else {
            localStorage.setItem("liked_property", JSON.stringify(properties));
        }

        return properties;
    }

    function validatePropertyData() {
        $("#viewed-properties-rent").empty();
        $("#liked-properties-rent").empty();
        $("#viewed-properties-sale").empty();
        $("#liked-properties-sale").empty();

        let type,
            viewed_property,
            liked_property;

        type = "vp";
        viewed_property = getProperties(type);
        validatePropertyDataAjax(viewed_property, type);

        type = "lp";
        liked_property = getProperties(type);
        validatePropertyDataAjax(liked_property, type);
    }

    function validatePropertyDataAjax(properties, type) {
        let validate_url = $("#validate-property-ajax").val();
        let _token = $("#_token").val();
        if (validate_url && _.size(properties) >= 1) {
            $.ajax({
                type: "POST",
                url: validate_url,
                data: {
                    _token: _token,
                    properties: properties,
                },
                success: function (data) {
                    if (data.properties.length > 0) {
                        // add a reverse here to counter the reverse happening somewhere
                        data.properties.reverse();
                        saveValidatedProperty(data.properties, type);
                    }
                },
                error: function (error) {
                    console.log(error);
                },
            });
        }
    }

    function saveValidatedProperty(properties, type) {        
        properties.forEach((property) => {
            let uuid = property.uuid;
            let title = property.title;
            let ja_title = property.ja_title;
            let zhcn_title = property.zhcn_title;
            let slug = property.slug;
            let ptype = property.ptype;

            properties = removeProperty(property, properties);
            if (typeof uuid !== "undefined") {
                properties = addValidatedProperty(
                    properties,
                    uuid,
                    title,
                    ja_title,
                    zhcn_title,
                    slug,
                    ptype
                );
            }
            setValidatedProperty(properties, type);
        });
    }

    function addValidatedProperty(
        arr,
        uuid,
        title,
        ja_title,
        zhcn_title,
        slug,
        ptype
    ) {
        item = {
            uuid: uuid,
            title: title,
            ja_title: ja_title,
            zhcn_title: zhcn_title,
            slug: slug,
            ptype: ptype,
        };
        arr.unshift(item);
        return arr;
    }

    function setValidatedProperty(properties, type) {    
        switch (type) {
            case "vp":
                localStorage.setItem(
                    "viewed_property",
                    JSON.stringify(properties)
                );
                break;
            case "lp":
                localStorage.setItem(
                    "liked_property",
                    JSON.stringify(properties)
                );
                break;
            default:
                break;
        }
    }
});
